import React, { useContext } from 'react';
import { Select, Popover, Button } from 'antd';
import { QuestionOutlined } from '@ant-design/icons';
import CompressionTable from './CompressionTable';
import State from '../State';
import { CompressionModeContext } from '../context/CompressionModeContextProvider';

const { compressionModes } = State;
const { Option } = Select;

const content = (
	<CompressionTable />
);

const SelectCompressionMode = props => {
	const { mode, update } = useContext(CompressionModeContext);
	function onValueChange(value) {
		update(State.compressionModes[value]);
		State.compressionMode = State.compressionModes[value];
	}
	const size = props.size || 'default';
	const showLabel = props.showLabel !== false;
	const showPopover = props.showPopover !== false;
	const { width } = props;
	const offset = window.innerWidth < 576 ? [0, 0] : [-114, 4];
	const popover = (
		<Popover
			content={content}
			trigger="hover"
			overlayClassName="compression-details-popover"
		>
			<Button size="small" style={{ marginLeft: 10 }} shape="circle" icon={<QuestionOutlined />} />
		</Popover>);
	return (
		<div>
			{ showLabel && <div className="action-name" >Compression Level</div> }
			<div className="select-compression-mode">
				<Select
					dropdownAlign={{
						offset
					}}
					defaultValue={mode.name}
					optionLabelProp="title"
					dropdownMatchSelectWidth={false}
					style={{ width }}
					onChange={onValueChange}
					size={size}
				>
					<Option
						className="select-option"
						value={compressionModes.Normal.name}
						title="Normal"
					>
						<span>Normal</span>
						<div>Less compression, better image quality</div>
					</Option>
					<Option
						className="select-option"
						value={compressionModes.Good.name}
						title="Good"
					>
						<span>Good (Recommended)</span>
						<div>Balanced compression & image quality</div>
					</Option>
					<Option
						className="select-option"
						value={compressionModes.High.name}
						title="High"
					>
						<span>High</span>
						<div>More compression, lower image quality</div>
					</Option>
					<Option
						className="select-option"
						value={compressionModes.Extreme.name}
						title="Extreme"
					>
						<span>Extreme (Not Recommended)</span>
						<div>Most compression, lowest image quality</div>
					</Option>
				</Select>
				{ showPopover && popover }
			</div>
		</div>
	);
};

export default SelectCompressionMode;



// WEBPACK FOOTER //
// ./src/components/SelectCompressionMode.js